import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click() {
    this.dpInput.onInputClick();
    this.dpInput.setFocus();
  }

  render() {
    const { value, onChange } = this.props;
    return (
      <div className="form" style={{ width: '140px', display: 'inline' }}>
        <div className="input-icon" style={{ width: '140px', display: 'inline' }}>
          <ReactDatePicker
            ref={instance => (this.dpInput = instance)}
            onChange={onChange}
            selected={value}
            dateFormat="DD/MM/YYYY"
          />
          <i className="icon-calendar" onClick={this.click} />
        </div>
      </div>
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/common/jsx/elements/inputs/DatePicker.js